var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSystemPlusOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.834 2a.5.5 0 0 1 .495.432l.005.068v4.833h4.836a.5.5 0 0 1 .068.996l-.068.004H8.335l.001 4.833a.5.5 0 0 1-.995.068l-.005-.068-.001-4.833H2.502a.5.5 0 0 1-.068-.995l.068-.005h4.833L7.334 2.5a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
})));
export default SvgIcSystemPlusOutline;